import React from 'react'

/**
 * NavChevronIndicator
 *
 * Visual affordance indicator for navigation items (topbar categories, submenus)
 * that contain nested children, options, or categories.
 *
 * Defaults:
 *   - Default (resting) state: 'expand_more'
 *   - Hovered/Active state: 'expand_less'
 * Both are configurable via props.
 */
export default function NavChevronIndicator({
  isHovered = false,
  defaultIcon = 'expand_more',
  hoverIcon = 'expand_less',
  className = '',
  ariaHidden = true,
}) {
  const currentIcon = isHovered ? hoverIcon : defaultIcon

  return (
    <span
      className={`material-symbols-outlined nav-chevron-indicator ${className}`}
      aria-hidden={ariaHidden}
    >
      {currentIcon}
    </span>
  )
}
